import React from "react";
import AutomationList from "../features/automations/AutomationList";
import Page from "../Components/Page";
import useFetchData from "../hooks/useFetchData";
import { IAutomation } from "../features/automations/types";
import { useTranslation } from "react-i18next";

export default function AutomationsPage() {
  const { data: automations, isLoading } =
    useFetchData<IAutomation[]>("/automations");
  const { t } = useTranslation();
  return (
    <Page title={t("Automations")} isLoading={isLoading}>
      {automations && <AutomationList automations={automations} />}
    </Page>
  );
}
